var render, staticRenderFns
import script from "./plan-discount-list.vue?vue&type=script&lang=jsx"
export * from "./plan-discount-list.vue?vue&type=script&lang=jsx"
import style0 from "./plan-discount-list.vue?vue&type=style&index=0&id=6eb0b844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports